import Vue from 'vue'
import { addGA } from '@/utils/assist'
import { updateConsentGA } from '@/utils/eu_popup'

export default new Vue({
  data() {
    return {
      player:{
        uid: null,
        gems: 0,
        w: 0
      },
      transify: {
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: 'purchased',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_NO_REMIND: '', // 需要默认值
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH: 'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      }
    }
  },
  methods: {
    addGA,
    checkGem(price) {
      let flag = true
      if (this.gems < price) {
        flag = false
      }
      return flag
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError(errCode) {
      // TODO 错误信息提示窗
      let message = this.transify[errCode] || this.transify['TOAST_NETWORK_ERROR']
      this.$message(message)
      // alert('TOAST error: ' + message)
      addGA('msgError', errCode)
    },
    updateConsentGA
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js